import { createSelector } from 'reselect'
import moment from 'moment'
import { isEqual } from 'lodash'
import { RootStoreState } from '@src/models/app.types'
import { calendarDateSelector, eventsFiltersTypesSelector } from '@src/selectors/app'
import { allEventsCalendarDateSelector } from '@src/screens/Events/models/allEvents.selectors'

export const eventsStoreStateSelector = (state: RootStoreState) => state.events

export const eventsObjectsSelector = (state: RootStoreState) =>
  eventsStoreStateSelector(state).events

export const eventsForDateSelector = createSelector(
  [eventsObjectsSelector, calendarDateSelector],
  (events, calendar) =>
    events.filter((event) => moment(event.occurredAt).isSame(calendar.startDate, 'day')),
  { memoizeOptions: { resultEqualityCheck: isEqual } },
)

export const eventsForDatesSelector = createSelector(
  [eventsObjectsSelector, calendarDateSelector],
  (events, calendar) =>
    events.filter((event) =>
      moment(event.occurredAt).isBetween(calendar.startDate, calendar.endDate, 'day', '[]'),
    ),
  { memoizeOptions: { resultEqualityCheck: isEqual } },
)

export const eventsSortSelector = createSelector(
  [eventsStoreStateSelector],
  (events) => events.sort,
  { memoizeOptions: { resultEqualityCheck: isEqual } },
)

export const eventsSelector = createSelector(
  [eventsStoreStateSelector, calendarDateSelector, eventsFiltersTypesSelector],
  (events, calendar, filters) => ({
    sort: events.sort,
    items: events.events,
    calendar,
    filters,
  }),
  { memoizeOptions: { resultEqualityCheck: isEqual } },
)

// Duplicate selector just for the allEvents selector
export const allEventsSelector = createSelector(
  [eventsStoreStateSelector, allEventsCalendarDateSelector, eventsFiltersTypesSelector],
  (events, calendar, filters) => ({
    sort: events.sort,
    items: events.events,
    calendar,
    filters,
  }),
  { memoizeOptions: { resultEqualityCheck: isEqual } },
)
